// translations
import i18n from 'i18';
import moment from 'moment';
// config
import config from 'config';

const helper = {
    async changeLanguage(lang) {
        localStorage.language = lang;
        lang === 'en' ? moment.locale('en-gb') : moment.locale(lang);
        await i18n.changeLanguage(lang);
        globalThis.forceUpdate();
    },

    formPageTitle(key) {
        return `${i18n.t(key)} | ${config.title}`;
    },
    labelDisplayedRows({ from, to, count }) {
        return `${from}-${to} ${i18n.t('text.of')} ${
            count !== -1
                ? count
                : `${i18n.t('text.moreThan')} ${to}`
        }`;
    },
    adaptedName(name) {
        return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    },
    removeIdFromName(name) {
        return name.replace(/Id$/, '');
    },
    getUserName(user) {
        if (!user) {
            return '';
        }
        return user.name ? user.name : `${user.firstName} ${user.lastName}`;
    },
    getWalletName(wallet) {
        const coinName = wallet?.coin?.name || '';
        const userName = helper.getUserName(wallet?.user);
        return `${userName || ''} - ${coinName}`;
    },
    formatFilterField(field, object) {
        if (object) {
            return `${object}.id`;
        }
        return field;
    },
    getStatusColor(status) {
        switch (status) {
        case 'auto_approved':
            return 'success';
        case 'pending':
            return 'warning';
        case 'manual_approved':
            return 'success';
        case 'active':
            return 'success';
        case 'pending_verification':
            return 'warning';
        case 'disabled':
            return 'error';
        case 'rejected':
            return 'error';
        case undefined:
            return 'error';
        default:
            return 'primary';
        }
    },
    transformUploadFiles(files) {
        if (!files) {
            return [];
        }
        return files.map((fileWr) => ({
            id: fileWr.file.id,
            name: fileWr.file.name,
            merchantLocationFileType: fileWr.merchantLocationFileType
        }));
    },
    transformUploadFile(file) {
        if (!file) {
            return null;
        }
        return {
            id: file.id,
            name: file.name,
        };
    },
};

export default helper;
